<template>
  <div>
    <b-row>
      <b-col sm="12">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="100"
          v-model="typeProduct.name" :markFormDirty="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <RadioGroup title="Tipo" field="type" :formName="formName" :options="[
          { text: 'Produto', value: 1 },
          { text: 'Acessório', value: 2 },
          { text: 'Material', value: 5 },
          { text: 'Serviço', value: 3 },
        ]" v-model="typeProduct.type" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSaveProductType" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveTypeProduct" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import TypeProduct from "@/components/modules/stock/type-product/TypeProduct.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "TypeProductCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { InputText, RadioGroup, Button },
  data() {
    return {
      formName: "typeProductCreateUpdate",
      typeProduct: new TypeProduct(),
      urlCreate: "/api/v1/stock/type-product/create",
      urlUpdate: "/api/v1/stock/type-product/update",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    saveTypeProduct() {
      if (this.typeProduct.id) {
        let params = { url: this.urlUpdate, obj: this.typeProduct };
        this.putApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          this.removeLoading(["btnSaveProductType"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.typeProduct };
        this.postApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          if (response.success && this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
            this.hideVodal(this.formName);
          }
          this.removeLoading(["btnSaveProductType"]);
        });
      }
    },
    update(data) {
      this.typeProduct = new TypeProduct();
      this.typeProduct.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "productTypeCreate") {
          this.resetValidation(this.formName);
          this.typeProduct = new TypeProduct();
        }
        if (event.name == "productTypeUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
